import {formatDate} from "@ui-seeker/utils";

export default function dateColumn() {
    return {
        name: "dateCreated", label: 'Date Created',
        options: {
            headerAlign: 'center',
            setCellProps: () => ({ sx: { textAlign: "center" } }),
            customBodyRowRender: value => formatDate(value, { isString: true})
        }
    }
}